import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { CHECK_PATH, HOUSE_PATH } from '@/components/generals/house-mark'

/**
 * Opening curtain. It runs on pure CSS so it never waits for scripts, and it only
 * plays on a full page load because _app never remounts on client navigation.
 */
export const Intro: FC = (): ReactNode => {
    const [mounted, setMounted] = useState(true)

    useEffect(() => {
        const timer = window.setTimeout(() => setMounted(false), 3200)

        return () => window.clearTimeout(timer)
    }, [])

    if (!mounted) return null

    return (
        <div className='intro' aria-hidden='true'>
            <svg viewBox='0 0 100 100' className='size-14 overflow-visible md:size-16'>
                <path
                    d={HOUSE_PATH}
                    pathLength={1}
                    className='intro__house fill-signal stroke-signal'
                    strokeWidth={7}
                    strokeLinejoin='round'
                />

                <path
                    d={CHECK_PATH}
                    pathLength={1}
                    className='intro__check stroke-paper'
                    fill='none'
                    strokeWidth={10}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        </div>
    )
}
